/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragmentArray } from 'ember-data-model-fragments/attributes';
import type Person from '@linc-technologies/linced-common/models/person';
import type School from '@linc-technologies/linced-common/models/school';
import type Day from '@linc-technologies/linced-common/models/timetable/day';

// Proto: timetable.Structure.
export default class Structure extends Model {
  declare [Type]: 'timetable/structure';

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  @attr('string', { defaultValue: '' })
  declare campusId: string;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string')
  declare effectiveFrom: string | undefined;

  @fragmentArray('timetable/day')
  declare days: FragmentArray<Day>;

  @attr('boolean', { defaultValue: false })
  declare archived: boolean;

  @attr('number')
  declare createTime: number | undefined;
}
